import React, { HTMLAttributes } from "react";
import ReactDOM from "react-dom";
import * as PropTypes from "prop-types";

class Placeholder extends React.Component {
  render() {
    return (
      <div
        style={{
          backgroundColor: "black",
          color: "white",
          height: "100%",
          width: "100%"
        }}
      >
        Loading
      </div>
    );
  }
}

export default Placeholder;
